import { defineType } from "sanity";
import { isPresent } from "../../utils/checks";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "hero",
  title: "Hero",
  options: {
    collapsible: true,
    collapsed: true
  },
  type: "object",
  fields: [
    {
      name: "variant",
      title: "Variant",
      type: "string",
      options: {
        list: [
          { title: "Default", value: "" },
          { title: "Boxed right (for LPs)", value: "boxed" },
          { title: "Default left", value: "left" }
        ]
      }
    },
    {
      name: "background",
      title: "Background",
      type: "imageWithAlt",
      validation: (Rule) => Rule.required()
    },
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayText"
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "ctaButtonsMobileOverride",
      title: "Override CTA Buttons on Mobile",
      description:
        "Use different CTA buttons on mobile devices (overrides the desktop CTA buttons)",
      type: "boolean"
    },
    {
      type: "ctaButtons",
      name: "ctaButtonsMobile",
      title: "CTA Buttons Mobile",
      options: {
        collapsible: true,
        collapsed: true
      },
      hidden: ({ parent }) => !parent?.ctaButtonsMobileOverride,
      validation: (Rule) =>
        Rule.custom((value: [], context) => {
          if ((context.parent as any)?.ctaButtonsMobileOverride) {
            if (!isPresent(value) || value.length === 0) {
              return "You must add at least one CTA button when override is enabled.";
            }
          }
          return true;
        })
    },
    {
      name: "calligraphicTitle",
      title: "Calligraphic Title",
      description: "use instead of `title`, but use only if forced!",
      type: "image",
      options: {
        hotspot: true,
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "calligraphicTitlePosition",
      title: "Calligraphic Title Position",
      type: "string",
      options: {
        list: [
          { title: "Left", value: "left" },
          { title: "Center", value: "center" },
          { title: "Right", value: "right" }
        ]
      }
    },
    {
      name: "countdownPromo",
      title: "Countdown promo",
      description: "This promo expire date is used as countdown expire time",
      type: "reference",
      to: [{ type: "exclusiveOfferPerPromo" }],
      hidden: ({ parent }) => parent?.variant !== "left"
    },
    {
      name: "countdownLabel",
      title: "Countdown label",
      type: "multilingualArrayString",
      hidden: ({ parent }) => parent?.variant !== "left"
    }
  ],
  preview: {
    select: {
      title: "title",
      background: "background"
    },
    prepare(selection) {
      const { title, background } = selection;
      return {
        title: multilingualStringPreview(title) || "Untitled Hero",
        media: background
      };
    }
  }
});
